import React, { useContext } from 'react';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { SubjectResult } from '../../util/buildQueries';
import { MeasurementColors } from '../../types';
import ColorContext from '../../ColorContext';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { darken } from '@mui/material/styles';
import clsx from 'clsx';

export const useStyles = makeStyles((theme: Theme) => ({
  referenceRangeValue: {
    lineHeight: theme.pxToRem(22),
    letterSpacing: theme.pxToRem(-0.75),
    marginBottom: theme.spacing(0.25),
    flex: 1,
    fontSize: 28,
  },
  reduceSize: {
    fontSize: 18,
  },
  reduceSizeMore: {
    fontSize: 14,
  },
}));

export const ValueBadge = (props: {
  status: SubjectResult['status'];
  value: React.ReactNode;
  colors?: Partial<MeasurementColors>;
}) => {
  const { status, value } = props;
  const colors = useContext(ColorContext);
  const colorsToUse = { ...colors, ...props.colors };
  const classes = useStyles();

  const color =
    {
      'in-range': colorsToUse.normal,
      attention: colorsToUse.bad,
      optimal: colorsToUse.optimal,
      default: colorsToUse.data,
      pending: colorsToUse.data,
    }[status] ?? colorsToUse.data;

  return (
    <Text
      className={clsx(
        classes.referenceRangeValue,
        String(value).length > 5 && classes.reduceSize,
        String(value).length > 20 && classes.reduceSizeMore,
      )}
      align="right"
      style={{ color: `${darken(color, 0.1)}` }}
      data-testid="value-badge"
    >
      {value}
    </Text>
  );
};
